import React, { ChangeEvent, useCallback } from 'react';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';
import { useTheme } from 'styled-components';
import { CheckboxProps } from './checkbox.type';

export const Checkbox: React.FC<CheckboxProps> = ({ onChange, name, checked = false, value, disabled, label }) => {
    const theme = useTheme();

    const onChangeHandler = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(event);
        }
    }, []);

    return (
        <div className="inline [&_.MuiTypography-root]:relative [&_.MuiTypography-root]:top-[-0.1rem] [&_.MuiTypography-root]:text-medium [&_.MuiTypography-root]:font-medium [&_.Mui-checked+_.MuiTypography-root]:text-brand-secondary [&_.Mui-checked+_.MuiTypography-root]:font-black">
            <FormControlLabel
                control={
                    <MuiCheckbox
                        name={name}
                        checked={checked}
                        disabled={disabled}
                        value={value}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeHandler(e)}
                        sx={{
                            '& .MuiSvgIcon-root': {
                                color: theme.palette.color.secondary.main,
                                fontWeight: theme.base.fontWeight,
                                fontFamily: theme.base.fontFace,
                                fontSize: theme.text.size.medium.fontSize,
                                width: '2.4rem',
                                height: '2.4rem',
                            },
                        }}
                    />
                }
                checked={checked}
                onChange={(event) => onChangeHandler(event as ChangeEvent<HTMLInputElement>)}
                value={value}
                label={label}
            />
        </div>
    );
};
